import { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'

const ARinformationForm = ({ navigation, route }: any): JSX.Element => {
  const formikRef = useRef(null)
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey
  } = params

  const options3 = [
    { key: 1, value: 'No' },
    { key: 2, value: 'Yes' }

  ]


  const options1 = [
    { key: 1, value: 'Single' },
    { key: 2, value: 'Married Filing Jointly' },
    { key: 3, value: 'Head of Household' },
  ]

  const intialValues = {
    filingStatus: "",
    noOfDependents: "",
    additionalAmount: "",
    qualifyLowIncome: ""
  }
  const alschema = yup.object({
    filingStatus: yup.string().required("Filing status is a required field"),
    noOfDependents: yup.string().required("Dependents is a required field"),
    additionalAmount: yup.string().nullable(),
    qualifyLowIncome: yup.string().required("Qualify low income tax is a required field"),

  })
  const { loading, postaronline } = useFormsStore()
  const initializestore = useInitializeStore()
  const personalstore = usePersonalStore()
  let noOfExemptions;
  let totalExcemptions;

  return (
    <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'AR Withholding Taxation '}
          />
        </View>
      </View>
      <View style={globalStyles.containerOverlap}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={alschema}
          onSubmit={async (values, actions) => {
            noOfExemptions = Number(values.filingStatus) == 1 ? 1 : 2
            totalExcemptions = noOfExemptions + Number(values.noOfDependents)

            const data = {
              essUserOnBoardingFormKey: essUserOnBoardingFormKey,
              essObKey: essUserOnBoardingKey,
              completeOnline: mode === 'online' ? true : false,
              essUserKey: initializestore.initializeData.userkey,
              entityId: personalstore.personalData?.entityId,
              filingStatus: values.filingStatus,
              noOfExemptions: noOfExemptions,
              noOfDependents: values.noOfDependents,
              totalExcemptions: totalExcemptions,
              additionalAmount: values.additionalAmount ? values.additionalAmount : null,
              qualifyLowIncome: Number(values.qualifyLowIncome) == 0 ? false : true
            }

            const response = await postaronline(data)

            if (response?.success) {
              if (mode === 'upload') {
                await Toast.show({
                  type: 'success',
                  position: 'bottom',
                  text1: response?.message,
                  visibilityTime: 3000,
                  autoHide: true,
                  topOffset: 60,
                  onHide: () => {
                    navigation.replace('OnboardingForms')
                  }
                })
              } else {
                navigation.navigate('ARInformationOnline', {
                  userId,
                  mode,
                  essUserOnBoardingKey,
                  essUserOnBoardingFormKey,
                  values,
                  noOfExemptions,
                  totalExcemptions
                })
              }
            } else {
              await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
              })
            }
          }}
        >
          {(props) => (
            <>
              <Card>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Filing Status *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title="Filing Status"
                      options={options1}
                      selectedOption={mapSelectValue(
                        options1,
                        props.values.filingStatus
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('filingStatus', option)
                      }}
                      textColor="primary"
                    />
                    {props.touched.filingStatus &&
                      props.errors.filingStatus && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.filingStatus}
                        </Text>
                      )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '30%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Number of Children or Dependents  *'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.noOfDependents}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('noOfDependents')(text)
                        }
                      }}
                    />
                    {props.touched.noOfDependents && props.errors.noOfDependents && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.noOfDependents}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '30%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'Additional amount, if any, you want deducted from each paycheck'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <TextInput
                      style={[globalStyles.input, globalStyles.inputLight]}
                      value={props.values.additionalAmount}
                      keyboardType="numeric"
                      onChangeText={(text) => {
                        if (text === '' || /^\d+$/.test(text)) {
                          props.handleChange('additionalAmount')(text)
                        }
                      }}
                    />
                    {props.touched.additionalAmount && props.errors.additionalAmount && (
                      <Text style={globalStyles.dangerAlert}>
                        {props.errors.additionalAmount}
                      </Text>
                    )}
                  </View>
                </View>
                <View
                  style={[
                    globalStyles.hDirection,
                    globalStyles.hBetweenItems,
                    globalStyles.mb2
                  ]}
                >
                  <View style={{ justifyContent: 'center', width: '50%' }}>
                    <Text
                      style={[
                        globalStyles.inputLabel,
                        globalStyles.inputLabelLarge,
                        globalStyles.inputLabelPrimary
                      ]}
                    >
                      {'I qualify for the low-income tax rates.*'}
                    </Text>
                  </View>
                  <View style={{ width: '28%', overflow: 'hidden' }}>
                    <SelectKeyValue
                      title={"I qualify for the low-income tax rates."}
                      options={options3}
                      selectedOption={mapSelectValue(
                        options3,
                        props.values.qualifyLowIncome
                      )}
                      onSelect={(option: any) => {
                        props.setFieldValue('qualifyLowIncome', option - 1)
                      }}
                      textColor="primary"
                    />
                    {props.touched.qualifyLowIncome &&
                      props.errors.qualifyLowIncome && (
                        <Text style={globalStyles.dangerAlert}>
                          {props.errors.qualifyLowIncome as string}
                        </Text>
                      )}
                  </View>
                </View>


                {loading ? (
                  <ActivityIndicator />
                ) : (
                  <View style={{ margin: 10 }}>
                    <CustomButton
                      text={mode === 'upload' ? 'Submit Information' : 'Next'}
                      onPress={props.handleSubmit}
                    />
                  </View>
                )}
              </Card>
            </>
          )}
        </Formik>
      </View>
    </KeyboardAwareScrollView>
  )
}
export default ARinformationForm
